/**
 * A file downloaded where the browser saves files, as a link with `download`
 * does: what a row's ⋯ menu, whose items are buttons, does for Download (the
 * templates' and the files' lists alike, byj-1wv.51.14, byj-1wv.51.17).
 */
export function download(href: string) {
  const a = document.createElement("a");
  a.href = href;
  a.download = "";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
